module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00691.4ff519be.jpg";